import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../../../services/apiService';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import compact from 'lodash/compact';
import get from 'lodash/get';
import { isNullOrEmpty as _isNullOrEmpty } from '../../../../../utils/vuex';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
export default {
  name: 'CoreDtwinStateAggregateEdit',
  components: {
    codemirror: codemirror
  },
  props: {
    lclModel: {
      type: Object,
      required: true
    },
    // is this an edit or new creation?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    tenantId: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      bindings: [],
      // bindings only contains states of twins the user has access to
      // fetchBinding might return an unauthorised error for others, but those should still be kept track of
      // use this array to compare before saving to make sure no state gets deleted just because there is no access for it
      originalBindings: [],
      aggregateStateLoops: false,
      aggregateStateValue: '',
      cmOptions: {
        tabSize: 4,
        mode: {
          name: 'javascript',
          json: true
        },
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: false
      }
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])),
  mounted: function mounted() {
    var _this = this;

    this.originalBindings = cloneDeep(get(this.lclModel, 'properties.binding.options.aggregateStateBindingIds') || []);
    this.originalBindings.forEach(function (id) {
      _this.fetchBinding(id);
    });
  },
  methods: {
    openDigitalTwin: function openDigitalTwin(dtwinId, bindingId) {
      window.open("#/digitaltwin-mgmt/".concat(dtwinId, "?stateId=").concat(bindingId), '_blank');
    },
    fetchBinding: function fetchBinding(bindingId) {
      var _this2 = this;

      ApiService.digitalTwinGetState(this, bindingId).then(function (binding) {
        _this2.bindings.push({
          dtwinId: binding.dtwinId,
          id: binding.id,
          key: binding.key,
          title: binding.properties.title
        });

        _this2.triggerBindingUiRefresh();
      }).catch(function (error) {
        // can fail silently, will just be filtered out
        console.error(error);
      });
    },
    triggerBindingUiRefresh: debounce(function () {
      // trigger UI refresh by cloning bindings
      this.bindings = cloneDeep(this.bindings);
      var bindingIds = compact(this.bindings.map(function (binding) {
        return binding.id;
      }));

      if (bindingIds.length) {
        this.refreshAggregateStateData();
      }
    }, 50, {
      leading: true
    }),
    refreshForm: function refreshForm() {
      var _this3 = this;

      setTimeout(function () {
        if (_this3.$refs.codemirror) {
          // required workaround to get the cursor appearing at the right spot
          // https://discuss.codemirror.net/t/codemirror-cursor-is-not-partially-visible/648/6
          _this3.$refs.codemirror.codemirror.refresh();

          _this3.$refs.codemirror.codemirror.focus();
        }
      }, 50);
    },
    refreshAggregateStateData: debounce(function () {
      var _this4 = this;

      var bindingIds = compact(this.originalBindings);

      if (bindingIds.length) {
        var promises = [ApiService.digitalTwinStatesGetAggregateValue(this, this.$route.params.id, {
          bindingIds: bindingIds
        })];

        if (this.mode !== 'create') {
          promises.push(ApiService.digitalTwinStateCheckForAggregateLoop(this, this.$route.params.id, this.lclModel.id, {
            aggregateStateIds: bindingIds
          }));
        }

        Promise.all(promises).then(function (result) {
          if (_this4.mode !== 'create') {
            _this4.aggregateStateLoops = result[1];
          }

          _this4.aggregateStateValue = result[0];

          _this4.refreshForm();

          _this4.$emit('aggregatedStateValue', _this4.aggregateStateValue);
        }).catch(function (error) {
          console.error(error);
        });
      }
    }, 750, {
      leading: true
    }),
    saveState: function saveState() {
      var _this5 = this;

      this.lclModel.properties.binding.options.aggregateStateBindingIds = [];
      this.originalBindings.forEach(function (id) {
        _this5.lclModel.properties.binding.options.aggregateStateBindingIds.push(id);
      });
    },
    addStateBinding: function addStateBinding(item) {
      this.originalBindings.push(item.id);
      this.bindings.push(item);
      this.triggerBindingUiRefresh();
    },
    removeStateBinding: function removeStateBinding(item) {
      this.originalBindings = this.originalBindings.filter(function (id) {
        return id !== item.id;
      });
      this.bindings = this.bindings.filter(function (b) {
        return b.id !== item.id;
      });
      this.triggerBindingUiRefresh();
    },
    isNullOrEmpty: function isNullOrEmpty(input) {
      return _isNullOrEmpty(input);
    }
  }
};